
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {Badge, Col, Container, Modal, Nav, NavItem, NavLink, Row} from 'reactstrap';
// core components
import NotificationAlert from "react-notification-alert";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import AppNavBar from "./AppNavBar";
import ReviewForm from "./pages/reviews/ReviewForm";
import auditService from "../services/auditService.js";
import AuditForm from "./pages/audit/AuditForm";
import RadarChart from "./RadarChart";
import auditData from "../util/auditData";

class AuditResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            contentData: {},
            answerId: this.props.match.params.uniqueId,
            surveyDetails: {},
            reviewFormKey: UtilService.uuidv4(),
            radarKey: UtilService.uuidv4(),
        };
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        let answerId = this.props.match.params.uniqueId;

        auditService.listQuestions().then((questions) => {
            this.setState({ surveyDetails: questions, reviewFormKey: UtilService.uuidv4() });

            auditService.getAnswer(answerId).then((answers) => {
                console.log("Raw answers:", answers);

                const mergedData = questions.map(question => {
                    const answer = answers.answers.find(a => a.questionId === question.uniqueId);
                    return {
                        ...question,
                        score: answer ? answer.score : 0  // or 0 if you want a fallback score
                    };
                });
                console.log("merged data:", mergedData)

                this.setState({
                    mergedData: mergedData,
                    transformedData: this.transformForRadarChart(mergedData),
                    radarKey: UtilService.uuidv4()
                });
                console.log(this.state.transformedData)
            });
        });
    }

    showExplanation = () => {
        const { transformedData } = this.state;

        return (
            <>
                {transformedData?.map((dataItem, index) => {
                    const feedback = this.getInternationalExpansionFeedback(dataItem.category, dataItem.average);
                    console.log(feedback)
                    return (
                        <div key={index} className="card">
                            <div className="card-header">
                                <h3 className="title">
                                    {dataItem.category} - <Badge color="primary" size="lg">Score - {dataItem.average.toFixed(2)}</Badge>
                                </h3>
                                <h5 className="title">
                                    <b>Why this is Important?</b> {feedback.importance}
                                </h5>
                            </div>
                            <div className="card-body">
                                <b>Feedback</b> - {feedback.feedback}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };


    getInternationalExpansionFeedback = (category, score) => {
        const categoryData = auditData[category];
        console.log(categoryData)
        if (!categoryData) return "Invalid category";

        score = parseFloat(score);
        console.log(score)
        let scoreKey = null;
        if (score > 4) scoreKey = "gt4";
        else if (score >= 2 && score <= 4) scoreKey = "btw2and4";
        else if (score < 2) scoreKey = "lt2";
        console.log(scoreKey)
        const result = categoryData.scores[scoreKey];
        console.log(result)
        if (!result) return "Score out of range";

        return {
            importance: categoryData.importance,
            feedback: result
        };
    }



    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

     transformForRadarChart = (data) => {
        const categoryMap = {};

        // Aggregate scores by category
        data.forEach((item) => {
            const { category, score } = item;
            if (!categoryMap[category]) {
                categoryMap[category] = { total: 0, count: 0 };
            }
            categoryMap[category].total += score;
            categoryMap[category].count += 1;
        });

        // Calculate averages and format for radar chart
        const radarData = Object.entries(categoryMap).map(([category, { total, count }]) => ({
            category,
            average: total / count,
        }));
        console.log("radarData", radarData)
        return radarData;
    };



    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        return (
            <div style={{backgroundColor: "white"}}>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Self-Assessment</p>
                                    <h1 style={{textAlign: "start"}}>Helping SMEs grow</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>

                <Container className="mt-10" style={{backgroundColor: "white"}}>
                    <Row>
                        <Col sm={"12"} md={"12"}>
                            <h1>Here is your Self Assessment result!</h1>
                            {this.state.mergedData && (
                                <div>
                                    <h2>Category-wise Performance</h2>
                                    <RadarChart key={this.state.radarKey}
                                        data={this.transformForRadarChart(
                                            this.state.mergedData // add more getAnswer responses if needed
                                        )}
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
                <br/>
                <Container className="mt-10" style={{backgroundColor: "white"}}>
                    <Row>
                        <Col sm={"12"} md={"12"}>
                            <h2>Recommendations based on your answers </h2>
                            <br/>
                            {this.showExplanation()}
                        </Col>
                    </Row>
                </Container>

                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default AuditResult;
